import type { UseQueryResult } from "@tanstack/react-query";

import { apiClient } from "app/modules/api-client";
import { useLLMReportQuery } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/hooks/useLLMReportQuery";
import type { ILLMWidgetRequestParams } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";

import type { ITopicsSummaryApiResponse } from "../topics-summary/types";

export const useTopicsSummaryData = (
    params: ILLMWidgetRequestParams,
    options?: { enabled?: boolean },
): UseQueryResult<ITopicsSummaryApiResponse> =>
    useLLMReportQuery<ITopicsSummaryApiResponse, ILLMWidgetRequestParams>(
        "topicsSummaryTable",
        apiClient.AiTracker.aiTrackerReportsBrandVisibilityReportTopicsVisibilityTableList,
        params,
        options,
    );
